import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyANmq2mq5B0cC4ikV2djDvV14p2yy9xnpk",
  authDomain: "metax-usa.firebaseapp.com",
  projectId: "metax-usa",
  storageBucket: "metax-usa.appspot.com",
  messagingSenderId: "328768066692",
  appId: "1:328768066692:web:50b474a363aac6f9c31ed1"
};
// Init Firebase Instance
firebase.initializeApp(firebaseConfig);
firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED // Setting Maximum Cache
});

// Enable Firebase Persistence
firebase.firestore().enablePersistence();

// Firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const timestamp = firebase.firestore.FieldValue.serverTimestamp();
const storage = firebase.storage();
const fb = firebase;
const usersCollection = db.collection("users");
const equipmentsCollection = db.collection("equipments");
const inspectionsCollection = db.collection("inspections");
const repairsCollection = db.collection("repairs");
const sparePartsCollection = db.collection("spareParts");
const reliabilitiesCollection = db.collection("reliabilities");
const functions = firebase.functions();

export {
  functions,
  reliabilitiesCollection,
  inspectionsCollection,
  usersCollection,
  equipmentsCollection,
  repairsCollection,
  sparePartsCollection,
  fb,
  auth,
  db,
  storage,
  timestamp
};
